import { render, staticRenderFns } from "./ClientsForAppt.vue?vue&type=template&id=9332269c&scoped=true"
import script from "./ClientsForAppt.vue?vue&type=script&lang=js"
export * from "./ClientsForAppt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9332269c",
  null
  
)

export default component.exports